import { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useSaveClinicMrnMutation } from "app/store/transmission/api/transmissionNotesApi";

import {
  onClinicMrnChange,
  selectedReport,
  toggleSubmitting,
} from "app/store/transmission/slice/transmissionSlice";
import { showErrorToast, showSuccessToast } from "utils/toast";

const useClinicMrn = (data) => {
  const dispatch = useDispatch();

  const {
    reportId,
    clinicMrnTouched,
    clinicMrnSubmitting,
    clinicMrn,
    isLegacyReport,
    reportDetail,
    alertStatus,
    attentionStatus,
  } = useSelector((state) => state.transmission);

  useEffect(() => {
    if (data?.patient.mrn) {
      dispatch(
        onClinicMrnChange({
          mrn: data?.patient.mrn,
          mrnTouched: false,
        })
      );
    }
  }, [data?.patient.mrn, dispatch]);

  const [saveClinicMrn] = useSaveClinicMrnMutation();

  const onSaveClinicMrn = async () => {
    try {
      dispatch(toggleSubmitting({ type: "clinicMrn", value: true }));

      const result = await saveClinicMrn({
        patientId: data?.patient?._id,
        patientMrn: clinicMrn,
      }).unwrap();

      if (result) {
        showSuccessToast("Patient MRN updated successfully");
        dispatch(onClinicMrnChange({ mrn: clinicMrn, mrnTouched: false }));

        dispatch(
          selectedReport({
            id: reportId,
            isLegacyReport: isLegacyReport,
            reportDetail: {
              ...reportDetail,
              alert_flag: alertStatus,
              warning_flag: attentionStatus,
              patient: { ...reportDetail?.patient, mrn: clinicMrn },
            },
          })
        );
      }
    } catch (err) {
      showErrorToast(err?.data?.message);
    } finally {
      dispatch(toggleSubmitting({ type: "clinicMrn", value: false }));
    }
  };

  return {
    dispatch,
    clinicMrn,
    clinicMrnTouched,
    clinicMrnSubmitting,
    onSaveClinicMrn,
  };
};

export default useClinicMrn;
